export default __webpack_public_path__ + "static/media/pantry2-after1-2048w.6cb9cc8b.webp";